var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxShowAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 8C8.60333 8 8 7.39667 8 6.66667C8 6.43067 8.06867 6.21133 8.17867 6.018C8.11867 6.01333 8.06133 6 8 6C7.47065 6.00349 6.96397 6.21533 6.58965 6.58965C6.21533 6.96397 6.00349 7.47065 6 8C6 9.09467 6.90533 10 8 10C9.094 10 10 9.09467 10 8C10 7.93867 9.98667 7.88133 9.982 7.82133C9.78867 7.93133 9.56933 8 9.33333 8Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84158 7.94705L1.84168 7.94708L1.84465 7.93757C1.84428 7.93877 1.84471 7.93761 1.84596 7.93421C1.87138 7.86516 2.23691 6.87227 3.14844 5.88189C4.09232 4.85635 5.62004 3.83203 7.99954 3.83203C10.379 3.83203 11.9068 4.85635 12.8507 5.8819C13.7773 6.88852 14.1409 7.8988 14.1567 7.94276C14.1572 7.94414 14.1573 7.94457 14.1572 7.94402L14.1577 7.9457L14.1751 7.99795L14.1575 8.05035L14.1574 8.05032L14.1544 8.05981C14.1548 8.05863 14.1544 8.05979 14.1531 8.06319C14.1277 8.13223 13.7622 9.12513 12.8506 10.1155C11.9068 11.141 10.379 12.1654 7.99954 12.1654C5.62004 12.1654 4.09232 11.141 3.14834 10.1155C2.22178 9.10886 1.8582 8.09856 1.84239 8.05463C1.84189 8.05326 1.84174 8.05283 1.84192 8.05338L1.84137 8.0517L1.824 7.99945L1.84158 7.94705ZM2.25708 7.79916L2.17026 7.99865L2.25704 8.19815C2.62043 9.03351 4.13134 11.832 7.99954 11.832C11.8656 11.832 13.3772 9.03639 13.742 8.19823L13.8288 7.99875L13.742 7.79925C13.3787 6.96389 11.8677 4.16536 7.99954 4.16536C4.1335 4.16536 2.62187 6.96101 2.25708 7.79916Z",
    fill: "#495057",
    stroke: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxShowAlt);
export default __webpack_public_path__ + "static/media/bx-show-alt.49b586e578dd4dd9c7f7bbd7aeed99d1.svg";
export { ForwardRef as ReactComponent };